import { render } from "./Planets.vue?vue&type=template&id=0fa3f5da&scoped=true"
import script from "./Planets.vue?vue&type=script&lang=js"
export * from "./Planets.vue?vue&type=script&lang=js"

import "./Planets.vue?vue&type=style&index=0&id=0fa3f5da&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa3f5da"]])

export default __exports__